export default function IntroductionSection() {
  return (
    <section id="introduction" className="py-20 md:py-32 px-6 bg-[#f8f6f0] relative overflow-hidden">
      {/* Washi Texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="max-w-7xl mx-auto relative">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest-800 mb-4">
            あさぎり荘について
          </h2>
          <div className="w-24 h-1 bg-gold-600 mx-auto"></div>
        </div>

        {/* Content */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[400px] md:h-[500px] rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/cc91b7789a14262b14655463cd9fff45/e2d7393af49f2078cd1097b26140b06b.jpeg"
                alt="あさぎり荘の和室"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="space-y-6">
            <h3 className="font-serif text-2xl md:text-3xl font-semibold text-forest-800 mb-6">
              温かいおもてなし
            </h3>
            <p className="text-gray-700 leading-relaxed text-base">
              兵庫県養父市ハチ高原のスキー場近くにあるアットホームな和風民宿です。木の温もりを感じる客室、心落ち着く和室、季節ごとの旬を活かした料理を提供しています。
            </p>
            <p className="text-gray-700 leading-relaxed text-base">
              ハチ高原の自然に寄り添い、森に包まれるやすらぎの時間をお過ごしいただけます。自然散策や四季の風景、地域の文化体験、スキー・スノーボード・登山など、様々なアクティビティーを満喫できます。
            </p>
            <p className="text-gray-700 leading-relaxed text-base">
              スポーツ合宿や研修、文化系合宿など、さまざまな目的に合わせてご利用いただける宿泊施設として、学生のみなさまの思い出に残る時間をサポートします。
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-4 pt-6">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-gold-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-forest-800">体育館完備</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-gold-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-forest-800">高原料理</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-gold-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-forest-800">団体利用可</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-gold-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-forest-800">駐車場無料</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}